/**
 * Non-command messages relayed between TV and Remotes (and to/from the embedded
 * Jitsi meeting). Seeded VERBATIM from spot-client `remote-control/constants.ts`
 * `MESSAGES`. These are pass-through/proxy messages distinct from the typed
 * {@link ./commands COMMANDS}; the room-do relays them between endpoints.
 */
export const MESSAGES = {
    /** A Spot-Remote is no longer connected to a Spot-TV. */
    CLIENT_LEFT: 'remote-control-client-left',

    /** A Spot-Remote message to be passed into the Jitsi meeting. */
    CLIENT_PROXY_MESSAGE: 'remote-control-client-message',

    /** A wireless-screensharing update from Jitsi, relayed TV -> Remote. */
    JITSI_MEET_UPDATE: 'update-message-from-jitsi-meet',

    /** A Remote -> TV update intended to be passed into the Jitsi meeting. */
    REMOTE_CONTROL_UPDATE: 'update-message-from-remote-control',

    /** A message to establish a P2P signaling channel. */
    REMOTE_CONTROL_P2P: 'remote-control-p2p'
} as const;

/** Every valid relay-message name (the wire string). */
export type MessageName = (typeof MESSAGES)[keyof typeof MESSAGES];

/**
 * Custom namespaces the legacy IQ protocol used to distinguish a command-IQ from
 * a message-IQ. Carried into the envelope `kind` discriminator (see
 * {@link ./envelope}). Kept for fidelity with the existing client.
 */
export const IQ_NAMESPACES = {
    COMMAND: 'jitsi-meet-spot-command',
    MESSAGE: 'jitsi-meet-spot-message'
} as const;

/**
 * How long to wait for an ack before considering a command timed out, ms.
 * Seeded from the legacy `IQ_TIMEOUT`.
 */
export const ACK_TIMEOUT_MS = 5000;
